require("bootstrap")
import "../stylesheets/application";


// Enable tooltips and popovers in each turbolinks visit
$(document).on('turbolinks:load', function () {
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
  
  $('input#self_service').click(function() {
    $('input:radio[name="lead_investor_insurance_insurance_request[request_method]"][value="self_service"]').prop('checked', true);
  });

  $('input#felmarys').click(function() {
    $('input:radio[name="lead_investor_insurance_insurance_request[request_method]"][value="felmarys"]').prop('checked', true);
  });

  $('#buttonmailstep1').click(function(event) {
    event.preventDefault();
    $('#lead_investor_insurance_insurance_request_email').removeClass('is-valid');
    $('#mailstep1').addClass('d-none');
    $('#mailstep2').removeClass('d-none');
  });

  $('#buttonmailstep2').click(function(event) {
    event.preventDefault();
    $('.info-mail').html($('#lead_investor_insurance_insurance_request_email').val())
    $('#mailstep2').addClass('d-none');
    $('#mailstep1').removeClass('d-none');
  });


  $('.grid-plan-steps').click(function() {

    var plan = $(this).data('plan');
    if(plan == 'plan1') {
      $('input:radio[id="lead_investor_insurance_insurance_request_plan_basic"]').prop('checked', true);
    } else if(plan == 'plan2') {
      $('input:radio[id="lead_investor_insurance_insurance_request_plan_standard"]').prop('checked', true);
    } else if(plan == 'plan3') {
      $('input:radio[id="lead_investor_insurance_insurance_request_plan_premium"]').prop('checked', true);
    }
    
    $('.grid-plan-steps').each(function() {
      $(this).children(':first-child')
        .removeClass('bg-rent')
        .addClass('bg-light-white')
        .children(':first-child')
        .removeClass('text-white')
        .addClass('text-dark-blue');
      $(this).children(':last-child')
        .removeClass('btn-border-green');
    });
  
    $(this).children(':first-child')
      .removeClass('bg-light-white')
      .addClass('bg-rent')
      .children(':first-child')
      .removeClass('text-dark-blue')
      .addClass('text-white');
      $(this).children(':last-child')
        .addClass('btn-border-green');
    });

  $('input:radio[name="lead_investor_insurance_insurance_request[plan]"]:checked').each(function() {
    var radio = $(this).val()
    var button;
    if(radio == 'basic') {
      button = $('.grid-plan-steps[data-plan="plan1"]');
    } else if(radio == 'standard') {
      button = $('.grid-plan-steps[data-plan="plan2"]');
    } else if(radio == 'premium') {
      button = $('.grid-plan-steps[data-plan="plan3"]');
    }
  
    $(button).children(':first-child')
    .removeClass('bg-light-white')
    .addClass('bg-rent')
    .children(':first-child')
    .removeClass('text-dark-blue')
    .addClass('text-white');
    
    $(button).children(':last-child')
    .addClass('btn-border-green');
  });

  $( document ).ready(function() {
    let ruts = document.querySelectorAll("[id$='_rut']");
    let phones = document.querySelectorAll("[id$='_phone_number']");
    let roles = document.querySelectorAll("[id$='_role_number']");
    let rutMaskOptions = {
      mask: '00.000.000-[0K]'
    };
    let phoneMaskOptions = {
      mask: '+{56}000000000'
    };
    let rolesMaskOptions = {
      mask: /([0-9-])$/
    };
    ruts.forEach((element) => {
      IMask(element, rutMaskOptions);
    })
    phones.forEach((element) => {
      IMask(element, phoneMaskOptions);
    })
    roles.forEach((element) => {
      IMask(element, rolesMaskOptions);
    })

    if(window.location.href.indexOf('#rent') > -1) {
      $('html, body').animate({
        scrollTop: $("#rent").offset().top - $('.navbar-light').outerHeight() - 10
      }, 0);
    }
    $("select[id$='_warehouse']").change(function() {
      $("#"+$(this).attr('id').replace("_warehouse", "_nwarehouse")).toggle();
    });

    $("select[id$='_parking']").change(function() {
      $("#"+$(this).attr('id').replace("_parking", "_nparking")).toggle();
    });

    $("select[id$='_property_type']").change(function() {
      console.log(this, $(this))
      let value = $(this).val();
      if(value === 'house') {
        $("#"+$(this).attr('id').replace("_property_type", "_napartment")).hide();
        $("#"+$(this).attr('id').replace("_property_type", "_ncondominium")).hide();
      } else {
        $("#"+$(this).attr('id').replace("_property_type", "_napartment")).show();
        $("#"+$(this).attr('id').replace("_property_type", "_ncondominium")).show();
      }
    });

    let tabIndex = 1;
    if($('a[role="tab"]')) {
      $('a[role="tab"]').each(function() {
        $(this).attr('tabindex', () => tabIndex++);
      });
    }

    $('input, select').not('input[type=button], input[type=submit], input[type=reset]').each(function() {
      $(this).attr('tabindex', () => tabIndex++);
    });

    $('input[type=submit]#send').attr('tabindex', tabIndex + 1);
    $('input[type=submit]#add').attr('tabindex', tabIndex + 2);
    $('#back').attr('tabindex', tabIndex + 3);
    $('.delete').attr('tabindex', tabIndex + 4);
  });

  $( "body" ).on( "click", ".bQoxsn",function() {
    $( ".togg" ).toggleClass( "d-none" );
    $( ".iLZqDP" ).toggleClass( "d-none" );
    
  } );
  
  $( "body" ).on( "click", ".fqrYSTu",function() {
    $( ".toggd" ).toggleClass( "d-none" );
    $( ".cLXKqM" ).toggleClass( "d-none" );
    $( "body" ).toggleClass( "overflow-hidden" );
    
    
  } );

  

});

// Disable tooltips and popovers before caching 
// preventing double rendering
$(document).on('turbolinks:before-cache', function () {
  $('[data-toggle="tooltip"]').tooltip('dispose')
  $('[data-toggle="popover"]').popover('dispose')
});


// Handle ajax forms
$(document).on('ajax:success', function (event) {
  const nextUrl = event.detail[0].next_url;
  const errors = event.detail[0].errors;

  if (errors) {
    const alerts = $(".alert-danger")
    alerts.removeClass("d-none");
    alerts.text(errors.join(', '))

    $(window).scrollTop($(".alert-danger").offset().top - 100);
    // $('html, body').animate({
    //   scrollTop: $(".alert-danger").offset().top - 100
    // }, 500);
  }
  if (nextUrl) {
    window.location.href = nextUrl;
  }
});

window.accept = function accept(label){
  var check = document.getElementById('lead_investor_insurance_insurance_request_terms_of_service')
  if(check.checked == false){
    check.checked = true
    label.classList.add('label-check')
  }else{
    check.checked = false
    label.classList.remove('label-check')
  }
}

window.checkRut = function checkRut(rut){
  var valor = rut.value.replace('.','');
  valor = valor.replace('-','');
  var cuerpo = valor.slice(0,-1);
  var dv = valor.slice(-1).toUpperCase();
  rut.value = cuerpo + '-'+ dv
  if(cuerpo.length < 7) { rut.setCustomValidity("RUT Incompleto"); return false;}
  var suma = 0;
  var multiplo = 2;
  for(var i=1;i<=cuerpo.length;i++) {
      var index = multiplo * valor.charAt(cuerpo.length - i);
      suma = suma + index;
      if(multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }
  }
  var dvEsperado = 11 - (suma % 11);
  dv = (dv == 'K')?10:dv;
  dv = (dv == 0)?11:dv;
  if(dvEsperado != dv) { rut.setCustomValidity("RUT Inválido"); return false; }
  rut.setCustomValidity('');
}
